/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartEmailReplacementRequestOmitted
 */
export interface StartEmailReplacementRequestOmitted {
    /**
     * 
     * @type {string}
     * @memberof StartEmailReplacementRequestOmitted
     */
    email: string;
}

/**
 * Check if a given object implements the StartEmailReplacementRequestOmitted interface.
 */
export function instanceOfStartEmailReplacementRequestOmitted(value: object): value is StartEmailReplacementRequestOmitted {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function StartEmailReplacementRequestOmittedFromJSON(json: any): StartEmailReplacementRequestOmitted {
    return StartEmailReplacementRequestOmittedFromJSONTyped(json, false);
}

export function StartEmailReplacementRequestOmittedFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartEmailReplacementRequestOmitted {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function StartEmailReplacementRequestOmittedToJSON(json: any): StartEmailReplacementRequestOmitted {
    return StartEmailReplacementRequestOmittedToJSONTyped(json, false);
}

export function StartEmailReplacementRequestOmittedToJSONTyped(value?: StartEmailReplacementRequestOmitted | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

